module.exports = __webpack_public_path__ + "static/img/RYDER-BUGG.b4ea200.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/RYDER-BUGG.jpg
// module id = KxVU
// module chunks = 0